import { useDispatch } from 'react-redux'
import { useFrameBridge } from '@hooks/useFrameBridge'
import * as chatContract from '@core/bridge/contracts/chatContract'
import { CHAT_CONNECTION_ID, FROM_CHAT } from '@core/bridge/contracts/chatContract'
import { ackHandshake, sendDisplayMode } from '@core/chat/chatClient'
import { closeChat, setChatConnected, setChatReady } from '@slices/uiSlice'

/**
 * Wires the chat iframe into the generic bridge and owns the chat handshake:
 * on the child's retrying READY we ACK, push the initial display config, and
 * mark the connection live; the child's close ✕ only *notifies* us, so the
 * parent performs the actual close.
 */
export const useChatBridge = ({ iframeRef, showCloseIcon = true, enabled = true }) => {
  const dispatch = useDispatch()

  const handleEvent = (type) => {
    switch (type) {
      case FROM_CHAT.READY:
        ackHandshake()
        sendDisplayMode({ showCloseIcon })
        dispatch(setChatConnected(true))
        dispatch(setChatReady(true))
        break
      case FROM_CHAT.CLOSE_ACTION:
        dispatch(closeChat())
        break
      default:
        break
    }
  }

  return useFrameBridge({
    id: CHAT_CONNECTION_ID,
    iframeRef,
    allowedOrigin: chatContract.getChatOrigin(),
    contract: chatContract,
    onEvent: handleEvent,
    enabled,
  })
}
